(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('MedReportLine', MedReportLine);

    MedReportLine.$inject = ['$resource'];

    function MedReportLine ($resource) {
        var resourceUrl =  'api/med-report-lines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
